<template>
  <div class="auto-page">
    <!-- Image hero optionnelle -->
    <NuxtImg 
      v-if="heroImage" 
      :src="heroImage" 
      :alt="heroAlt" 
      class="w-full h-auto mb-4" 
      loading="eager" 
      fetchpriority="high" sizes="100vw" />
    
    <!-- Container principal -->
    <div class="container mx-auto px-4 max-w-4xl">
      <!-- Breadcrumb automatique -->
      <AutoBreadcrumb v-if="showBreadcrumb" />
      
      <!-- Titre de la page -->
      <h1 v-if="title" class="text-4xl font-light my-16 text-center text-black">{{ title }}</h1>
      
      <!-- Contenu de la page -->
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">


interface Props {
  title?: string
  heroImage?: string
  heroAlt?: string
  showBreadcrumb?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  showBreadcrumb: true,
  heroAlt: 'Page hero image'
})
</script>

<style scoped>
.auto-page {
  font-family: 'Playfair Display', Georgia, serif;
  background: #fff;
  letter-spacing: 0.01em;
}

.auto-page h1, .auto-page h2, .auto-page h3 {
  color: #111;
}

.auto-page p, .auto-page li {
  color: #222;
}
</style> 
